export default "__VITE_ASSET__f91a0f74__"